<template>
  <div id="app" :class="{ dark: isDarkMode }">
    <div class="min-h-screen bg-background text-foreground">
      <!-- Loading State -->
      <LoadingSpinner 
        v-if="isLoading" 
        :overlay="true"
        :dark-mode="isDarkMode"
        :message="loadingMessage"
        size="large"
      />

      <!-- Main App -->
      <router-view v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useThemeStore } from '@/stores/theme'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const authStore = useAuthStore()
const themeStore = useThemeStore()

const isLoading = computed(() => authStore.isLoading)
const isDarkMode = computed(() => themeStore.isDarkMode)

const loadingMessage = computed(() => {
  switch (authStore.loadingType) {
    case 'init':
      return 'Initializing application...'
    case 'logout':
      return 'Signing out...'
    case 'login':
      return 'Signing in...'
    default:
      return 'Loading...'
  }
})

onMounted(async () => {
  // Initialize theme
  await themeStore.initializeTheme()
  
  // Initialize authentication
  await authStore.initialize()
})
</script>

<style>
/* Global styles are handled in main.css */
</style>
